import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M8.75 3.25a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0m0 8.75a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0m0 8.75a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0-6.5 0"
    }, null, -1)
  ]));
}
const interfaceDotsVertical = { render };
export {
  interfaceDotsVertical as default,
  render
};
//# sourceMappingURL=interface-dots-vertical.svg.js.map
